/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetChatSummariesResponseData,
  GetChatSummariesResponseDataFromJSON,
  GetChatSummariesResponseDataFromJSONTyped,
  GetChatSummariesResponseDataToJSON
} from './GetChatSummariesResponseData'

/**
 *
 * @export
 * @interface GetChatSummariesResponse
 */
export interface GetChatSummariesResponse {
  /**
   *
   * @type {number}
   * @memberof GetChatSummariesResponse
   */
  status?: number
  /**
   *
   * @type {GetChatSummariesResponseData}
   * @memberof GetChatSummariesResponse
   */
  data?: GetChatSummariesResponseData
}

export function GetChatSummariesResponseFromJSON(json: any): GetChatSummariesResponse {
  return GetChatSummariesResponseFromJSONTyped(json, false)
}

export function GetChatSummariesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetChatSummariesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetChatSummariesResponseDataFromJSON(json['data'])
  }
}

export function GetChatSummariesResponseToJSON(value?: GetChatSummariesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetChatSummariesResponseDataToJSON(value.data)
  }
}
